/* eslint-disable function-paren-newline */
/* eslint-disable indent */

export class MasterMatrixController {

	/**
	 * @param {import('extensions/multi-system/types').MasterMatrix} matrix
	 * @param {import('lit').LitElement} [host]
	 */
	constructor (matrix, host) {
		(this.host = host)?.addController(this);

		/**
		 * @type {import('extensions/multi-system/types').MasterMatrix}
		 */
		this.matrix = matrix;
	}

	/**
	 * Only support R32 since max 5 rooms
	 */
	determineMatrixType () {
		return 'R32';
	}

	/**
	 * Input an array of current selections and output the available capcity classes from the given matrix.
	 * @param {string[][]} selections
	 * @param {number} roomIndex
	 * @param {number} roomCount
	 */
	getAvailableCapacityClasses (selections, roomIndex, roomCount) {
		const matrixRows = this.matrix[this.determineMatrixType()] ?? [];
		const available = matrixRows
			.map(row => row.filter(val => val !== '0'))
			.filter(row => row.length === roomCount &&
				selections.every((sel, i) => !sel || sel.includes(row[i]))
			)
			.map(row => row[roomIndex]);
		return Array.from(new Set(available));
	}
};
